import { useState, useCallback, useEffect } from 'react';
import useRequest from './useRequest';

export interface FeaturesState {
  funds: boolean;
  projects: boolean;
  branches: boolean;
  warehouses: boolean;
}

export function useFeatures() {
  const { http } = useRequest();
  const [features, setFeatures] = useState<FeaturesState | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Fetch current features
  const fetchFeatures = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await http.get('/api/settings/features');
      setFeatures(data);
    } catch (err: any) {
      setError(err?.message || 'Failed to fetch features');
    } finally {
      setLoading(false);
    }
  }, [http]);

  // Update features
  const updateFeatures = useCallback(
    async (newFeatures: FeaturesState) => {
      setLoading(true);
      setError(null);
      try {
        console.log('newFeatures', newFeatures);
        await http.post('/api/settings/features', newFeatures);
        setFeatures(newFeatures);
      } catch (err: any) {
        setError(err?.message || 'Failed to update features');
      } finally {
        setLoading(false);
      }
    },
    [http]
  );

  useEffect(() => {
    fetchFeatures();
  }, [fetchFeatures]);

  return {
    features,
    loading,
    error,
    fetchFeatures,
    updateFeatures,
  };
} 